






























import { Component, Vue, Provide } from "vue-property-decorator";
import { configuration } from "@/config/host.config";
import { IConfigurationSign } from "@/@types/filoxenia-config/tv-config";
import { BModal } from "bootstrap-vue";

import BackgroundConfig from "@/components/apps-configuration/tv/bacground-config.vue";
import LogoConfig from "@/components/apps-configuration/tv/logo-config.vue";
import TvMenuConfig from "@/components/apps-configuration/tv/tv-menu-config.vue";

@Component({
  name: "sign-configuration",
  components: {
    BackgroundConfig,
    TvMenuConfig,
    LogoConfig,
  },
})
export default class SignConfiguration extends Vue {
  @Provide() backgroundFolder = "main/configuration/background/sign";
  @Provide() logoFolder = "main/configuration/logo";

  background = "";
  logo = "";

  showBackgroundForm = false;
  showLogoForm = false;
  config: IConfigurationSign | null = null;

  $refs!: {
    navmodal: BModal;
  };

  get logoAccess(): boolean {
    return process.env.VUE_APP_CHANGE_LOGO ? true : this.$getRootPermition();
  }

  async updateConfig(data: Partial<IConfigurationSign>): Promise<void> {
    try {
      const config = { params: { app: "sign" } };
      const configRes = await this.$axios.put(
        configuration.mainAPI,
        data,
        config
      );
      if (configRes.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.createConfiguration();
      } else
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
    } catch (error) {
      console.log(error);
    }
  }

  createConfigParams(data: IConfigurationSign): void {
    this.background = data.background;
    this.logo = data.logo;
    this.config = data;
  }

  async createConfiguration(): Promise<void> {
    try {
      const config = {
        params: { "match[app]": "sign" },
      };
      const configRes = await this.$axios.get(configuration.mainAPI, config);
      if (configRes.status === 200) {
        this.createConfigParams(configRes.data.configurationsign);
      }
    } catch (error) {
      console.log(error);
    }
  }

  mounted(): void {
    this.createConfiguration();
  }
}
